"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("./settlementManageState");
const react_device_detect_1 = require("react-device-detect");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1() {
    const { id: roomId, room_type_cd, room_status_cd, entered_waybill_count, } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementDetailsDataState);
    // ? [배너] 제작비 정산> 일정 마감해 주세요: ROOM_STATUS_01(모금중) 일 때 표시
    // ? [배너] 제작비 정산> 배송 예정일을 늦춰주세요: ROOM_STATUS_03(제작중=지연) 일 때 표시
    const isLimitedSales = room_type_cd === 'ROOM_TYPE_00';
    const needSalesClosed = isLimitedSales && room_status_cd === 'ROOM_STATUS_01';
    const needDeliveryDateDelayed = isLimitedSales && room_status_cd === 'ROOM_STATUS_03';
    const needRegisterWaybill = entered_waybill_count === 0;
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const RequirementLink = ({ link, title, desc, }) => ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: "no_anchor_deco surface-primary-light", href: link, css: {
            display: 'flex',
            flexDirection: maxWidth768 ? 'column' : 'row',
            alignItems: maxWidth768 ? 'flex-start' : 'center',
            justifyContent: maxWidth768 ? 'center' : 'space-between',
            gap: '2px 12px',
            width: '100%',
            padding: `${maxWidth768 ? '10px' : '12px'} 16px`,
            borderRadius: '8px',
            svg: { flexShrink: 0 },
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: maxWidth768 ? '4px' : '8px',
                } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.WarningTriangleRedSvg, { css: {
                            width: maxWidth768 ? '20px' : '24px',
                            height: maxWidth768 ? '20px' : '24px',
                        } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle4 gray-80" }, { children: title })), maxWidth768 && (0, jsx_runtime_1.jsx)(svgs_1.ChevronRightSvg, { css: { width: '20px', height: '20px' } })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "caption1 gray-40", css: {
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '4px',
                    textAlign: maxWidth768 ? 'unset' : 'right',
                    wordBreak: 'keep-all',
                } }, { children: [desc, !maxWidth768 && (0, jsx_runtime_1.jsx)(svgs_1.ChevronRightSvg, { css: { width: '20px', height: '20px' } })] }))] })));
    const { t } = (0, react_i18next_1.useTranslation)();
    if (!roomId)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            display: 'flex',
            flexDirection: maxWidth768 ? 'row' : 'column-reverse',
            gap: '12px 10px',
            padding: maxWidth768 ? '10px 16px' : '0',
        } }, { children: [(needSalesClosed || needDeliveryDateDelayed) && ((0, jsx_runtime_1.jsx)(RequirementLink, { link: `/room/room_edit/?room_id=${roomId}`, title: t('제작비 정산'), desc: t(needSalesClosed ? '일정 마감해 주세요' : '배송 예정일을 늦춰주세요') })), needRegisterWaybill && ((0, jsx_runtime_1.jsx)(RequirementLink, { link: react_device_detect_1.isDesktop
                    ? `/room/refund_manager_pc/?roomId=${roomId}`
                    : `/room/upload_waybill/?roomId=${roomId}`, title: t('정산'), desc: t('운송장 등록해 주세요') }))] })));
}
exports.default = default_1;
